import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'

export interface DataSource {
  id: string
  name: string
  source_type: string
  is_active: boolean
  last_sync_at: string | null
  config: Record<string, unknown>
  created_at: string
}

export interface CreateSourcePayload {
  name: string
  source_type: string
  config: Record<string, string>
}

export function useSources() {
  return useQuery<DataSource[]>({
    queryKey: ['sources'],
    queryFn: () => api.get<DataSource[]>('/api/v1/sources'),
  })
}

export function useCreateSource() {
  const qc = useQueryClient()
  return useMutation<DataSource, Error, CreateSourcePayload>({
    mutationFn: (payload) => api.post<DataSource>('/api/v1/sources', payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['sources'] }),
  })
}

export function useSyncSource() {
  const qc = useQueryClient()
  return useMutation<void, Error, string>({
    mutationFn: (id) => api.post<void>(`/api/v1/sources/${id}/sync`, {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['sources'] }),
  })
}

export function useDeleteSource() {
  const qc = useQueryClient()
  return useMutation<void, Error, string>({
    mutationFn: (id) => api.delete<void>(`/api/v1/sources/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['sources'] }),
  })
}
